// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

type ActivityDropDownContainerStyleProps = {
    isOpened: boolean;
    isDisabled: boolean;
};

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;

export const ActivityDropDownContainer = styled.div<ActivityDropDownContainerStyleProps>`
    width: 100%;
    border: 1px solid;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    position: relative;

    ${({ isOpened, isDisabled }) => {
        if (isDisabled) {
            return css`
                border-color: ${theme.colors.base[200]};
                background-color: ${theme.colors.base[200]};

                cursor: not-allowed;
            `;
        }

        if (isOpened) {
            return css`
                border-color: ${theme.colors.base[200]};
                background-color: #ffffff;

                @media (min-width: 768px) {
                    border-radius: 4px 4px 0 0;
                    border-color: ${theme.colors.system.info[300]};
                    background-color: #ffffff;
                    border-bottom-color: transparent;
                }
            `;
        }

        return css`
            border-color: ${theme.colors.base[300]};
            background-color: #ffffff;
        `;
    }}
`;

export const ActivityDropDownContent = styled.div`
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    gap: 16px;

    padding: 10px;

    cursor: pointer;
`;

export const ActivityDropDownPlaceholderWrapper = styled.div`
    width: 100%;

    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ActivityDropDownPlaceholder = styled.p`
    font-family: "Nunito Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${theme.colors.base[400]};
`;

export const ActivityDropDownIconWrapper = styled.div`
    display: flex;
    flex-shrink: 0;
`;
export const ActivityDropDownIcon = styled.img`
    flex-shrink: 0;
    width: 16px;
    height: 16px;
`;

export const DropdownOpenedContainer = styled.div`
    width: calc(100% + 2px);
    padding: 0 12px 12px;
    background-color: #ffffff;
    border: 1px solid ${theme.colors.system.info[300]};
    border-top: none;
    border-radius: 0 0 4px 4px;

    position: absolute;
    top: 100%;
    left: -1px;

    z-index: 2;
`;

export const ActivityDropDownAdditionalContentLabelWrapper = styled.div`
    width: 100%;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
`;

export const ActivityDropDownAdditionalContentIcon = styled.img`
    flex-shrink: 0;
    width: 12px;
    height: 12px;
`;

export const ActivityDropDownAdditionalContentLabel = styled.p`
    font-family: "Nunito Sans", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: ${theme.colors.base[400]};
`;

export const ActivityDropDownOptionItemCompositionsWrapper = styled.div`
    border-top: 1px solid ${theme.colors.base[200]};

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    padding-top: 12px;

    max-height: 320px;
    overflow-y: auto;
`;

export const ActivityOptionItemContainer = styled.div`
    width: 100%;
    padding: 10px 12px;

    border-radius: 4px;
    background-color: #ffffff;

    display: flex;
    align-items: center;
    gap: 8px;

    transition: background-color 0.2s ease-in-out;

    cursor: pointer;

    > p {
        width: 100%;

        transition: color 0.2ms ease-in-out;
    }

    &:hover {
        background-color: ${theme.colors.base[100]};

        > p {
            color: #3e68d2;
            font-weight: 700;
        }
    }
`;

type ActivityOptionItemLabelStyleProps = {
    isActive: boolean;
};

export const ActivityOptionItemLabel = styled.p<ActivityOptionItemLabelStyleProps>`
    font-family: "Nunito Sans", sans-serif;
    font-weight: ${({ isActive }) => (isActive ? 700 : 400)};
    font-size: 14px;
    line-height: 20px;
    color: ${theme.colors.base[400]};
`;

export const ErrorMessageWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding-top: 4px;

    > img {
        margin-bottom: 2px;
    }
`;

export const ErrorMessageIcon = styled.img`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
`;

export const ErrorMessageLabel = styled.p`
    font-family: "Nunito Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    color: ${theme.colors.system.danger[300]};
`;

export const ActivityDropdownNoOptionsLabel = styled.p`
    font-family: "Nunito Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${theme.colors.base[400]};
`;

export const ActivityDropdownInputAndOptionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
